webpackJsonp([62701403028825],{

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Dm = __webpack_require__(91);
	
	var _Dm2 = _interopRequireDefault(_Dm);
	
	var _Wb = __webpack_require__(92);
	
	var _Wb2 = _interopRequireDefault(_Wb);
	
	var _Bb = __webpack_require__(90);
	
	var _Bb2 = _interopRequireDefault(_Bb);
	
	var _Divider = __webpack_require__(6);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _DividerW = __webpack_require__(66);
	
	var _DividerW2 = _interopRequireDefault(_DividerW);
	
	var _Fill = __webpack_require__(5);
	
	var _Fill2 = _interopRequireDefault(_Fill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WebSolutions = function WebSolutions() {
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'full-Width' },
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-25 mobBottommargin', style: {} },
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'block' } },
	              _react2.default.createElement(
	                'h1',
	                { className: 'smallerHone' },
	                'Services'
	              ),
	              _react2.default.createElement('img', { src: _Divider2.default, alt: 'Nisadhya - Divider', style: { margin: '.75rem 0' } }),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'biggerText gradient' },
	                  'Strategy, design and a bit of magic.'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                { style: { marginBottom: '0' } },
	                'Nisadhya Pvt. Ltd is a Nepal based Digital Marketing Company that constantly strives to provide the best branding and digital marketing solutions.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-75 homeServicesContainer paddingLeft spaceBetween', style: { alignItems: 'baseline' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'half-Width-30' },
	              _react2.default.createElement(
	                'div',
	                { className: 'centerAlign homeServices' },
	                _react2.default.createElement('img', { src: _Dm2.default, alt: 'Digital Marketing in Nepal' }),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/services/digital-marketing/', className: 'slide' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Digital Marketing'
	                  )
	                ),
	                _react2.default.createElement('img', { src: _Fill2.default, alt: 'Nisadhya - Divider', style: { margin: '.75rem auto' } }),
	                'Social Media',
	                _react2.default.createElement('br', null),
	                'Google Ads',
	                _react2.default.createElement('br', null),
	                'SEO'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'half-Width-30' },
	              _react2.default.createElement(
	                'div',
	                { className: 'centerAlign homeServices' },
	                _react2.default.createElement('img', { src: _Wb2.default, alt: 'Website Development in Nepal' }),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/services/web-solutions/', className: 'slide' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Web Solutions'
	                  )
	                ),
	                _react2.default.createElement('img', { src: _Fill2.default, alt: 'Nisadhya - Divider', style: { margin: '.75rem auto' } }),
	                'Website Design',
	                _react2.default.createElement('br', null),
	                'Website Development',
	                _react2.default.createElement('br', null),
	                'Web Hosting'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'half-Width-30' },
	              _react2.default.createElement(
	                'div',
	                { className: 'centerAlign homeServices', style: { marginBottom: '0' } },
	                _react2.default.createElement('img', { src: _Bb2.default, alt: 'Corporate Branding in Nepal' }),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/services/brand-development/', className: 'slide' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Brand Development'
	                  )
	                ),
	                _react2.default.createElement('img', { src: _Fill2.default, alt: 'Nisadhya - Divider', style: { margin: '.75rem auto' } }),
	                'Corporate Branding',
	                _react2.default.createElement('br', null),
	                'Logo Design',
	                _react2.default.createElement('br', null),
	                'Brand Strategy'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'block' } },
	          _react2.default.createElement(
	            'h1',
	            { className: 'smallerHone' },
	            'Web Solutions'
	          ),
	          _react2.default.createElement('img', { src: _Divider2.default, alt: 'Nisadhya - Divider', style: { margin: '.75rem 0' } }),
	          _react2.default.createElement(
	            'p',
	            { className: 'smallerHone' },
	            _react2.default.createElement(
	              'span',
	              { className: 'gradient' },
	              'Case studies such as these inspire and motivate us.'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: { marginBottom: '0' } },
	            'See how businesses similar to yours are growing with Digital Marketing.'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = WebSolutions;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-web-solutions-index-js-73623c3795c48152cbf5.js